import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { TripTypePropDefault } from '../../models/TripType';
import { setTripType } from '../../redux/currentSearch/actions';
import { getTripType } from '../../redux/currentSearch/selectors';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { TrackingUtils } from '../../utils';

const TripTypeSelector = React.memo(({ render, trackEvent }) => {
    const dispatch = useDispatch();
    const value = useSelector((state) => getTripType(state)) || TripTypePropDefault;
    const onTripTypeChange = (value) => {
        dispatch(setTripType(value));
        const label = TrackingUtils.LABEL.tripTypeSelect(value);
        trackEvent({ action: TrackingUtils.ACTION.FLIGHTS, label });
    };
    return render(value, onTripTypeChange);
});

TripTypeSelector.propTypes = {
    render: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
};

const TripTypeSelectorWithPageContext = withPageContext(TripTypeSelector);
export { TripTypeSelectorWithPageContext as TripTypeSelector };
